import { useQuery, type UseQueryResult } from '@tanstack/react-query'
import { fetchDashboard } from '../api/client'
import { MOCK_DASHBOARD } from '../api/mockDashboard'
import type { DashboardPayload, DashboardView } from '../types/api'

export function toDashboardView(payload: DashboardPayload): DashboardView {
  return {
    storeLabel: payload.store.name,
    storeCode: payload.store.code,
    storeOpen: payload.store.open,
    liveSplh: payload.live_splh,
    targetSplh: payload.target_splh,
    activeClockins: payload.active_clockins,
    scheduledShifts: payload.scheduled_shifts,
    prepCompletedPans: payload.prep.completed_pans,
    prepTotalPans: payload.prep.total_pans,
    prepCompletionPct: payload.prep.completion_pct,
    pendingProcurementOrders: payload.pending_procurement_orders,
    unreadReviews: payload.unread_reviews,
    currency: payload.currency,
    generatedAt: payload.generated_at,
    modules: payload.modules,
    isLive: true,
  }
}

/**
 * Loads the dashboard snapshot from `GET /api/v1/mock/dashboard`.
 *
 * `placeholderData` keeps the shell populated with realistic Salsa Shop numbers
 * while the request is in flight or when the backend is offline.
 */
export function useDashboard(): UseQueryResult<DashboardPayload, Error> {
  return useQuery<DashboardPayload, Error>({
    queryKey: ['store', 'dashboard'],
    queryFn: fetchDashboard,
    placeholderData: {
      store: {
        id: 104,
        code: MOCK_DASHBOARD.storeCode,
        name: MOCK_DASHBOARD.storeLabel,
        city: 'Eindhoven',
        country: 'NL',
        timezone: 'Europe/Amsterdam',
        open: MOCK_DASHBOARD.storeOpen,
      },
      live_splh: MOCK_DASHBOARD.liveSplh,
      target_splh: MOCK_DASHBOARD.targetSplh,
      active_clockins: MOCK_DASHBOARD.activeClockins,
      scheduled_shifts: MOCK_DASHBOARD.scheduledShifts,
      prep: {
        completed_pans: MOCK_DASHBOARD.prepCompletedPans,
        total_pans: MOCK_DASHBOARD.prepTotalPans,
        completion_pct: MOCK_DASHBOARD.prepCompletionPct,
      },
      pending_procurement_orders: MOCK_DASHBOARD.pendingProcurementOrders,
      unread_reviews: MOCK_DASHBOARD.unreadReviews,
      currency: MOCK_DASHBOARD.currency,
      generated_at: MOCK_DASHBOARD.generatedAt,
      modules: MOCK_DASHBOARD.modules,
    },
    refetchInterval: 60_000,
    retry: 1,
  })
}
